<div class="skeleton-timeline-container">
  <!-- Above timeline: Congresses -->
  <div class="skeleton-section-divider">
    <div class="skeleton-toggle">
      <app-skeleton-block width="14px" height="14px" borderRadius="2px"></app-skeleton-block>
      <app-skeleton-block width="80px" height="11px" borderRadius="2px"></app-skeleton-block>
    </div>
    <div class="skeleton-divider-line"></div>
  </div>

  <div class="skeleton-row">
    <div class="skeleton-row-header">
      <app-skeleton-block width="11px" height="70px" borderRadius="2px"></app-skeleton-block>
    </div>
    <div class="skeleton-row-content">
      @for (card of aboveCards; track $index) {
        <div class="skeleton-month-column">
          <div class="skeleton-card">
            <app-skeleton-block width="28px" height="28px" borderRadius="8px"></app-skeleton-block>
            <div class="skeleton-card-body">
              <app-skeleton-block width="60px" height="10px" borderRadius="8px"></app-skeleton-block>
              <app-skeleton-block width="90%" height="14px" borderRadius="4px"></app-skeleton-block>
              <app-skeleton-block width="60%" height="12px" borderRadius="4px"></app-skeleton-block>
            </div>
          </div>
        </div>
      }
    </div>
  </div>

  <!-- Above timeline: Milestones -->
  <div class="skeleton-section-divider">
    <div class="skeleton-toggle">
      <app-skeleton-block width="14px" height="14px" borderRadius="2px"></app-skeleton-block>
      <app-skeleton-block width="72px" height="11px" borderRadius="2px"></app-skeleton-block>
    </div>
    <div class="skeleton-divider-line"></div>
  </div>

  <div class="skeleton-row">
    <div class="skeleton-row-header">
      <app-skeleton-block width="11px" height="70px" borderRadius="2px"></app-skeleton-block>
    </div>
    <div class="skeleton-row-content">
      @for (card of aboveCards; track $index) {
        <div class="skeleton-month-column">
          <div class="skeleton-card">
            <app-skeleton-block width="28px" height="28px" borderRadius="8px"></app-skeleton-block>
            <div class="skeleton-card-body">
              <app-skeleton-block width="60px" height="10px" borderRadius="8px"></app-skeleton-block>
              <app-skeleton-block width="80%" height="14px" borderRadius="4px"></app-skeleton-block>
              <app-skeleton-block width="50%" height="12px" borderRadius="4px"></app-skeleton-block>
            </div>
          </div>
        </div>
      }
    </div>
  </div>

  <!-- Timeline axis -->
  <div class="skeleton-timeline-axis">
    @for (month of months; track $index) {
      <div class="skeleton-month-marker">
        <div class="skeleton-dot"></div>
        <app-skeleton-block width="48px" height="12px" borderRadius="4px"></app-skeleton-block>
      </div>
    }
    <div class="skeleton-axis-line"></div>
  </div>

  <!-- Below timeline: Publications -->
  <div class="skeleton-section-divider">
    <div class="skeleton-toggle">
      <app-skeleton-block width="14px" height="14px" borderRadius="2px"></app-skeleton-block>
      <app-skeleton-block width="88px" height="11px" borderRadius="2px"></app-skeleton-block>
    </div>
    <div class="skeleton-divider-line"></div>
  </div>

  <div class="skeleton-row">
    <div class="skeleton-row-header">
      <app-skeleton-block width="11px" height="70px" borderRadius="2px"></app-skeleton-block>
    </div>
    <div class="skeleton-row-content">
      @for (card of belowCards; track $index) {
        <div class="skeleton-month-column">
          <div class="skeleton-card">
            <app-skeleton-block width="28px" height="28px" borderRadius="8px"></app-skeleton-block>
            <div class="skeleton-card-body">
              <app-skeleton-block width="60px" height="10px" borderRadius="8px"></app-skeleton-block>
              <app-skeleton-block width="95%" height="14px" borderRadius="4px"></app-skeleton-block>
              <app-skeleton-block width="70%" height="12px" borderRadius="4px"></app-skeleton-block>
              <div class="skeleton-tags">
                <app-skeleton-block width="56px" height="18px" borderRadius="999px"></app-skeleton-block>
                <app-skeleton-block width="72px" height="18px" borderRadius="999px"></app-skeleton-block>
              </div>
            </div>
          </div>
        </div>
      }
    </div>
  </div>

  <!-- Below timeline: Activities -->
  <div class="skeleton-section-divider">
    <div class="skeleton-toggle">
      <app-skeleton-block width="14px" height="14px" borderRadius="2px"></app-skeleton-block>
      <app-skeleton-block width="68px" height="11px" borderRadius="2px"></app-skeleton-block>
    </div>
    <div class="skeleton-divider-line"></div>
  </div>

  <div class="skeleton-row">
    <div class="skeleton-row-header">
      <app-skeleton-block width="11px" height="70px" borderRadius="2px"></app-skeleton-block>
    </div>
    <div class="skeleton-row-content">
      @for (card of belowCards; track $index) {
        <div class="skeleton-month-column">
          <div class="skeleton-card">
            <app-skeleton-block width="28px" height="28px" borderRadius="8px"></app-skeleton-block>
            <div class="skeleton-card-body">
              <app-skeleton-block width="85%" height="14px" borderRadius="4px"></app-skeleton-block>
              <app-skeleton-block width="55%" height="12px" borderRadius="4px"></app-skeleton-block>
            </div>
          </div>
        </div>
      }
    </div>
  </div>

  <!-- Below timeline: Materials -->
  <div class="skeleton-section-divider">
    <div class="skeleton-toggle">
      <app-skeleton-block width="14px" height="14px" borderRadius="2px"></app-skeleton-block>
      <app-skeleton-block width="64px" height="11px" borderRadius="2px"></app-skeleton-block>
    </div>
    <div class="skeleton-divider-line"></div>
  </div>

  <div class="skeleton-row">
    <div class="skeleton-row-header">
      <app-skeleton-block width="11px" height="70px" borderRadius="2px"></app-skeleton-block>
    </div>
    <div class="skeleton-row-content">
      @for (card of belowCards; track $index) {
        <div class="skeleton-month-column">
          <div class="skeleton-card">
            <app-skeleton-block width="28px" height="28px" borderRadius="8px"></app-skeleton-block>
            <div class="skeleton-card-body">
              <app-skeleton-block width="75%" height="14px" borderRadius="4px"></app-skeleton-block>
              <app-skeleton-block width="45%" height="12px" borderRadius="4px"></app-skeleton-block>
            </div>
          </div>
        </div>
      }
    </div>
  </div>
</div>
